import styled from 'styled-components'
import media from 'styles/media'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
`

const CouponImage = styled.img`
  flex-shrink: 0;
  object-fit: cover;
  width: 64px;
  height: 36px;
  border-radius: 4px;
`

const CouponDetails = styled.div`
  align-self: start;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  flex-grow: 1;
  padding-left: 16px;

  @media (${media.screenSmMiniMax}) {
    padding-left: 8px;
  }
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Condition = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  align-self: end;
  column-gap: 4px;
  color: ${({ theme }) => theme.colors.infoDark};
`

export { Wrapper, CouponImage, CouponDetails, Condition, FlexContainer, ColumnContainer }
